import React, {useEffect, useState} from "react";
import {collection, doc, onSnapshot, query, where} from "firebase/firestore";
import {db} from "./Admin";
import {number, percent, rub, ruDate, sum} from "./utils";
import css from "../css/admin.module.css";
import Paper from "@mui/material/Paper";
import {Tooltip} from "@mui/material";
import {AdminDialog} from "./AdminDialog";


const getMergedData = (stat) => {
    if (!stat) return;
    const merging = (lead, user, key) => {
        lead[key] && lead[key].forEach(l => {
            if (user[key]) {
                const u = user[key].find(u => JSON.stringify(u.id).toLowerCase() === JSON.stringify(l.id).toLowerCase());
                if (u) {
                    u.count = u.count + l.count;
                    u.last = Math.max(u.last, l.last);
                } else {
                    user[key].push(l)
                }
            }
        })
    }
    const data = {};
    stat.forEach((lead) => {
        const userId = lead.userId;
        const leadId = lead.id;

        if (userId) {
            if (!data[userId]) {
                const user = lead;
                user.leadIds = [leadId];
                data[userId] = user;
            } else {
                const user = data[userId];
                user.leadIds.push(leadId);

                merging(lead, user, "ip");
                merging(lead, user, "browser");
                merging(lead, user, "referrer");
                merging(lead.event, user.event, "click");
                merging(lead.event, user.event, "load");
                merging(lead.event, user.event, "post");

                user.created = Math.min(user.created, lead.created);
            }
        } else {
            data[leadId] = lead;
        }
    });
    return Object.values(data);
}
const addBrowser = (stat) => {
    const detectBrowser = (id) => {
        const {userAgent, authPlatform} = id;
        //return userAgent;

        if (authPlatform) return authPlatform;

        if (/bot|Baiduspider/i.test(userAgent)) {
            return 'Bot';
        }

        if (/chrome|crios|crmo/i.test(userAgent) && !/edge|edg/i.test(userAgent)) {
            return 'Google Chrome';
        }
        if (/firefox|fxios/i.test(userAgent)) {
            return 'Mozilla Firefox';
        }
        if (/safari/i.test(userAgent) && !/chrome|crios|crmo/i.test(userAgent)) {
            return 'Safari';
        }
        if (/edg/i.test(userAgent)) {
            return 'Microsoft Edge';
        }
        if (/opr|opera/i.test(userAgent)) {
            return 'Opera';
        }
        if (/msie|trident/i.test(userAgent)) {
            return 'Internet Explorer';
        }

        return userAgent;
    };
    stat.forEach(s => s.browser.forEach(b => b.id.browser = detectBrowser(b.id)))
    return stat
}
const botFilterBot = (stat) => {
    return stat.filter(s => !s.browser.map(b => b.id.browser).includes("Bot"))
}
const addDays = (stat) => {
    if (!stat) return;
    stat.forEach(f => {
        const dates = [...new Set(Object.keys(f.event).reduce((a, i) => {
            a.push(f.event[i].map(e => e.last));
            return a
        }, []).flat())].map(last => last);
        f.days = Math.floor((Math.max(...dates) - Math.min(...dates)) / 1000 / 60 / 60 / 24);
    });
    return stat
}
const addCampaignsInvoices = (campaigns, invoices, stat) => {
    stat.forEach(s => {
        s.campaign = campaigns.items.find(item => s.created >= item.start && s.created <= item.end) || {};
        s.invoices = invoices.filter(invoice => s.userId === invoice.userId) || [];

        s.quantity = sum(s.invoices.map(invoice => invoice.months));
        s.revenue = sum(s.invoices.map(invoice => invoice.cost));

        s.cogs = s.campaign.cogs * s.quantity;
        s.tax = s.campaign.tax * s.revenue;
        s.acquiring = s.campaign.acquiring * s.revenue;

        s.cost = s.acquiring + s.tax + s.cogs;
    })
    return stat
}
const campaignsItems = (campaigns, invoices, stat) => {
    const items = campaigns.items.filter(item => item.active);
    const mstat = addCampaignsInvoices({items}, invoices, botFilterBot(addBrowser(addDays(getMergedData(stat)))));

    const total = {ua: [], trials: [], customers: [], customers2: [], budget: 0};

    items.forEach(campaign => {
        const stat = mstat.filter(s => s.created >= campaign.start && s.created <= campaign.end);

        const ua = stat;
        const trials = posted(stat, "trialStart");
        const customers = posted(stat, "success");
        const customers2 = postedQuantity(stat, "success", 2);

        const c0 = trials.length / ua.length;
        const c1 = customers.length / trials.length;
        const c2 = customers2.length / customers.length;

        const budget = campaign.budget;

        const revenue = sum(ua.map(s => s.revenue));
        const quantity = sum(ua.map(s => s.quantity));
        const cost = sum(ua.map(s => s.cost)) + budget;

        const price = revenue / quantity;
        const profit = revenue - cost;

        const cac = budget / customers.length;
        const ltv = profit / customers.length;
        const romi = profit / budget;

        total.ua = [...total.ua, ...ua];
        total.trials = [...total.trials, ...trials];
        total.customers = [...total.customers, ...customers];
        total.customers2 = [...total.customers2, ...customers2];
        total.budget += campaign.budget;
        total.start = total.start ? Math.min(total.start, campaign.start) : campaign.start;
        total.end = total.end ? Math.max(total.end, campaign.end) : campaign.end;

        campaign.table = [
            {
                title: "Кампания", items: [
                    {data: campaign.id},
                    {data: campaign.channel},
                    {data: rub(campaign.budget)},
                    {data: ruDate(campaign.start)},
                    {data: ruDate(campaign.end)},
                    {data: rub(campaign.cogs)},
                    {data: percent(campaign.acquiring)},
                    {data: percent(campaign.tax)},
                ]
            },
            {
                title: "Экономика", items: [

                    {users: ua, data: number(ua.length)},
                    {users: trials, data: number(trials.length)},
                    {users: customers, data: number(customers.length)},
                    {users: customers2, data: number(customers2.length)},

                    {data: percent(c0)},
                    {data: percent(c1)},
                    {data: percent(c2)},

                    {data: rub(price)},
                    {data: number(quantity)},

                    {data: rub(cac)},
                    {data: rub(ltv)},


                    {data: rub(revenue)},
                    {data: percent(romi)},
                    {data: rub(cost)},
                    {data: rub(profit)},
                ]
            },
            {
                title: "Финансы", items: [
                    {users: ua},
                    {users: loaded(stat, "/app")},
                    {users: clicked(stat, "startTrialButton")},
                    {users: posted(stat, "trialStart")},
                    {users: posted(stat, "noCostInvoiceSuccess")},
                    {users: postedQuantity(stat, "noCostInvoiceSuccess", 2)},
                    {users: posted(stat, "success")},
                    {users: postedQuantity(stat, "success", 2)},
                ]
            },
            {
                title: "Вебсайт", items: [
                    {users: referrer(stat, "/qrcode")},
                    {users: loaded(stat, "/")},
                    {users: clicked(stat, "openAppButton")},
                ]
            },
            {
                title: "Задачи", items: [
                    {users: posted(stat, "problem")},
                    {users: clicked(stat, "goToProblems")},
                    {users: posted(stat, "solved")},
                    {users: clicked(stat, "showVideo")},
                    {users: clicked(stat, "showErrors")},
                    {users: clicked(stat, "nextProblem")},
                    {users: clicked(stat, "skipProblem")},
                ]
            },
            {
                title: "Статистика", items: [
                    {users: posted(stat, "statistics")},
                ]
            },
            {
                title: "Профиль", items: [
                    {users: posted(stat, "profile")},
                    {users: clicked(stat, "writeToDevelopers")},
                ]
            },
            {
                title: "Тарифы", items: [
                    {users: posted(stat, "tariffs")},
                    {users: clicked(stat, "chooseTariff-Start")},
                    {users: clicked(stat, "chooseTariff-Premium")},
                    {users: clicked(stat, "chooseTariff-Premium-1")},
                    {users: clicked(stat, "chooseTariff-Premium-3")},
                    {users: clicked(stat, "chooseTariff-Premium-6")},
                    {users: clicked(stat, "chooseTariff-Premium-12")},
                    {users: clicked(stat, "chooseTariff-VIP")},
                    {users: clicked(stat, "chooseTariff")},
                    {users: posted(stat, "invoiceCreate")},
                    {users: clicked(stat, "a1lite_button")},
                    {users: clicked(stat, "renewTariff")},
                ]
            },
            {
                title: "Срок жизни", items: [
                    {users: days(stat, 1)},
                    {users: days(stat, 2)},
                    {users: days(stat, 3)},
                    {users: days(stat, 4)},
                    {users: days(stat, 5)},
                    {users: days(stat, 6)},
                    {users: days(stat, 7)},
                    {users: days(stat, 30)},
                    {users: days(stat, 60)},
                    {users: days(stat, 90)},
                ]
            },
            {title: "Страны", items: calculatedItems(mstat, stat, ["ip", "id", "country"])},
            {title: "Языки", items: calculatedItems(mstat, stat, ["browser", "id", "language"], 4)},
            {title: "Платформа", items: calculatedItems(mstat, stat, ["browser", "id", "platform"])},
            {title: "Браузер", items: calculatedItems(mstat, stat, ["browser", "id", "browser"])},
        ];

    });

    total.c0 = total.trials.length / total.ua.length;
    total.c1 = total.customers.length / total.trials.length;
    total.c2 = total.customers2.length / total.customers.length;
    total.revenue = sum(total.ua.map(s => s.revenue));
    total.quantity = sum(total.ua.map(s => s.quantity));
    total.cost = sum(total.ua.map(s => s.cost)) + total.budget;

    total.cogs = sum(total.ua.map(s => s.campaign.cogs)) / total.ua.length;
    total.acquiring = sum(total.ua.map(s => s.acquiring)) / total.revenue;
    total.tax = sum(total.ua.map(s => s.tax)) / total.revenue;

    total.price = total.revenue / total.quantity;
    total.profit = total.revenue - total.cost;
    total.cac = total.budget / total.customers.length;
    total.ltv = total.profit / total.customers.length;
    total.romi = total.profit / total.budget;

    total.table = [
        {
            title: "Кампания", items: [
                {title: "#"},
                {title: "Channel", description: "Название канала", data: "Total"},
                {title: "Budget", description: "Маркетинговый бюджет кампании", data: rub(total.budget)},
                {title: "Start", description: "Начало", data: ruDate(total.start)},
                {title: "End", description: "Конец", data: ruDate(total.end)},
                {title: "COGS", description: "Расходы на 1 продукта", data: rub(total.cogs)},
                {title: "Acquiring", description: "Эквайринг", data: percent(total.acquiring)},
                {title: "Tax", description: "Налог", data: percent(total.tax)},
            ]
        },
        {
            title: "Экономика", items: [

                {
                    title: "UA",
                    users: total.ua,
                    data: number(total.ua.length),
                    description: "User Acquisition Уникальные посетители сайта"
                },
                {
                    title: "Trails",
                    users: total.trials,
                    data: number(total.trials.length),
                    description: "Согласился на Trial"
                },
                {
                    title: "Customers",
                    users: total.customers,
                    data: number(total.customers.length),
                    description: "Заплатившие один раз"
                },
                {
                    title: "Customers 2",
                    users: total.customers2,
                    data: number(total.customers2.length),
                    description: "Заплатившие два раза"
                },

                {title: "C0", data: percent(total.c0), description: "Конверсия Trial"},
                {title: "C1", data: percent(total.c1), description: "Конверсия первой покупки"},
                {title: "C2", data: percent(total.c2), description: "Конверсия второй покупки"},

                {title: "Price", data: rub(total.price), description: "Средний чек"},
                {title: "Quantity", data: number(total.quantity), description: "Среднее количество месяцев"},

                {title: "CAC", data: rub(total.cac), description: "Стоимость привлечения 1 платящего клиента"},
                {title: "LTV", data: rub(total.ltv), description: "Прибыль с 1 платящего клиента"},

                {title: "Revenue", data: rub(total.revenue), description: "Выручка. Доход"},
                {title: "ROMI", data: percent(total.romi), description: "Эффективность маркетинговых вложений"},
                {title: "Cost", data: rub(total.cost), description: "Расходы"},
                {title: "Profit", data: rub(total.profit), description: "Чистая прибыль"},
            ]
        },
        {
            title: "Финансы", items: [
                {title: "Уникальных заходов", users: total.ua},
                {title: "Зашли в Приложение", users: loaded(total.ua, "/app")},
                {title: "Нажали на Триал", users: clicked(total.ua, "startTrialButton")},
                {title: "Начали Триал", users: posted(total.ua, "trialStart")},
                {title: "Бесплатный Инвойс", users: posted(total.ua, "noCostInvoiceSuccess")},
                {title: "Бесплатный Инвойс второй раз", users: postedQuantity(total.ua, "noCostInvoiceSuccess", 2)},
                {title: "Оплатили Инвойс", users: posted(total.ua, "success")},
                {title: "Оплатили Инвойс второй раз", users: postedQuantity(total.ua, "success", 2)},
            ]
        },
        {
            title: "Вебсайт", items: [
                {title: "Зашли через QR-code", users: referrer(total.ua, "/qrcode")},
                {title: "Зашли на сайт", users: loaded(total.ua, "/")},
                {title: "Нажали на кнопку приложения", users: clicked(total.ua, "openAppButton")},
            ]
        },
        {
            title: "Задачи", items: [
                {title: "Зашли на страницу Задачи", users: posted(total.ua, "problem")},
                {title: "Нажали на перейти к задачам", users: clicked(total.ua, "goToProblems")},
                {title: "Ввели Решение", users: posted(total.ua, "solved")},
                {title: "Нажали на Видеорешение", users: clicked(total.ua, "showVideo")},
                {title: "Нажали на Фото ошибки", users: clicked(total.ua, "showErrors")},
                {title: "Нажали на Следующее", users: clicked(total.ua, "nextProblem")},
                {title: "Нажали на Пропустить", users: clicked(total.ua, "skipProblem")},
            ]
        },
        {
            title: "Статистика", items: [
                {title: "Зашли на страницу Статистика", users: posted(total.ua, "statistics")},
            ]
        },
        {
            title: "Профиль", items: [
                {title: "Зашли на страницу Профиль", users: posted(total.ua, "profile")},
                {title: "Нажали на написать разработчикам", users: clicked(total.ua, "writeToDevelopers")},
            ]
        },
        {
            title: "Тарифы", items: [
                {title: "Зашли на страницу Тарифов", users: posted(total.ua, "tariffs")},
                {title: "Нажали на тариф Start", users: clicked(total.ua, "chooseTariff-Start")},
                {title: "Нажали на тариф Premium", users: clicked(total.ua, "chooseTariff-Premium")},
                {title: "Нажали на тариф Premium 1", users: clicked(total.ua, "chooseTariff-Premium-1")},
                {title: "Нажали на тариф Premium 3", users: clicked(total.ua, "chooseTariff-Premium-3")},
                {title: "Нажали на тариф Premium 6", users: clicked(total.ua, "chooseTariff-Premium-6")},
                {title: "Нажали на тариф Premium 12", users: clicked(total.ua, "chooseTariff-Premium-12")},
                {title: "Нажали на тариф VIP", users: clicked(total.ua, "chooseTariff-VIP")},
                {title: "Нажали на выбрать тариф", users: clicked(total.ua, "chooseTariff")},
                {title: "Создали Инвойс", users: posted(total.ua, "invoiceCreate")},
                {title: "Нажали на оплатить Инвойс", users: clicked(total.ua, "a1lite_button")},
                {title: "Нажали на продлить", users: clicked(total.ua, "renewTariff")},
            ]
        },
        {
            title: "Срок жизни", items: [
                {title: "Пользуются 1 день", users: days(total.ua, 1)},
                {title: "Пользуются 2 день", users: days(total.ua, 2)},
                {title: "Пользуются 3 день", users: days(total.ua, 3)},
                {title: "Пользуются 4 день", users: days(total.ua, 4)},
                {title: "Пользуются 5 день", users: days(total.ua, 5)},
                {title: "Пользуются 6 день", users: days(total.ua, 6)},
                {title: "Пользуются 7 дней", users: days(total.ua, 7)},
                {title: "Пользуются 30 дней", users: days(total.ua, 30)},
                {title: "Пользуются 60 дней", users: days(total.ua, 60)},
                {title: "Пользуются 90 дней", users: days(total.ua, 90)},
            ]
        },
        {title: "Страны", items: calculatedItems(mstat, total.ua, ["ip", "id", "country"])},
        {title: "Языки", items: calculatedItems(mstat, total.ua, ["browser", "id", "language"])},
        {title: "Платформа", items: calculatedItems(mstat, total.ua, ["browser", "id", "platform"])},
        {title: "Браузер", items: calculatedItems(mstat, total.ua, ["browser", "id", "browser"])},
    ];


    return {total, items}
}

const clicked = (stat, id) => stat.filter(f => f.event.click?.some(c => c.id.id === id));
const loaded = (stat, id) => stat.filter(f => f.event.load?.some(c => c.id === id));
const posted = (stat, id) => stat.filter(f => f.event.post?.some(c => c.id === id));

const referrer = (stat, id) => stat.filter(f => f.referrer?.some(c => c.id && (new URL(c.id).pathname === id)));
const postedQuantity = (stat, id, quantity) => stat.filter(f => f.event.post?.some(c => c.id === id && c.count >= quantity));
const days = (stat, d) => stat.filter(f => f.days >= d);

const calculatedItems = (mstat, stat, [k0, k1, k2]) => {
    const users = (id) => stat.filter(f => f[k0]?.some(c => c[k1][k2] === id));
    const all = mstat.map(d => d[k0].map(ip => ip[k1][k2])).flat();
    const unique = [...new Set(all)];
    return unique.reduce((a, name) => [...a, {title: name, users: users(name)}], [])
}

const ShowUserData = ({stat}) => {

    return (
        <div className={css.ShowUserData}>
            <pre>
                {JSON.stringify(stat, null, "  ")}
            </pre>
        </div>

    )
}

export const Table = ({total, items}) => {
    return (
        <Paper elevation={3} className={css.campaigns}>
            <div className={css.container}>
                <table>
                    <thead>
                    <tr>
                        {total.table.map(({title, items}) => (
                            <th colSpan={items.length} key={title}>{title}</th>
                        ))}
                    </tr>
                    <tr>
                        {total.table.map(({items}) => items.map(({title, description}, i) => (
                            <th key={i}>
                                <Tooltip title={description}>
                                    {title}
                                </Tooltip>
                            </th>
                        )))}
                    </tr>
                    </thead>
                    <tbody>


                    {items.map(item => item.table).map((item, i) => (
                        <tr key={i}>
                            {item.map(({items}) => items.map(({users, data}, i) => (
                                <td key={i}>
                                    {users?.map && users.length ? <AdminDialog users={users}/> : data}
                                </td>
                            )))}
                        </tr>
                    ))}

                    <tr className={css.total}>
                        {total.table.map(({items}) => items.map(({users, data}, i) => (
                            <td key={i}>
                                {users?.map && users.length ? <AdminDialog users={users}/> : data}
                            </td>
                        )))}
                    </tr>


                    </tbody>
                </table>
            </div>
        </Paper>
    )
}

export const Campaigns = () => {
    const [stat, setStat] = useState(null);
    const [invoices, setInvoices] = useState(null);
    const [campaigns, setCampaigns] = useState(null);

    useEffect(() => {
        const unsubscribes = [];
        unsubscribes.push(onSnapshot(query(collection(db, "stat")), s => setStat(s.docs.map(doc => doc.data()))));
        unsubscribes.push(onSnapshot(query(collection(db, "invoices"), where("cost", ">", 0), where("success", "==", true), where("acquiringStatus", "==", "success")), s => setInvoices(s.docs.map(doc => doc.data()))));
        unsubscribes.push(onSnapshot(doc(db, "settings", "campaigns"), s => setCampaigns(s.data())));
        return () => unsubscribes.forEach(unsubscribe => unsubscribe())
    }, []);

    if (!stat || !invoices || !campaigns) return;

    const userId = new URLSearchParams(document.location.search).get("userId");
    if (userId) return <ShowUserData stat={stat.filter(s => s.userId === userId)}/>

    stat.map(s => console.log(s));


    const {total, items} = campaignsItems(campaigns, invoices, stat);

    return (
        <Table items={items} total={total}/>
    )
}

